import { render, staticRenderFns } from "./TipsLibrary.vue?vue&type=template&id=408cd753&"
import script from "./TipsLibrary.vue?vue&type=script&lang=ts&"
export * from "./TipsLibrary.vue?vue&type=script&lang=ts&"
import style0 from "./TipsLibrary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports